import { Box, RadioButtonGroup, Text } from 'grommet';
import React from 'react';
import { sentencecase } from '../utils/string';
import FontAwesomeIcon from './FontAwesomeIcon';

const TabToggle = ({options, value, name, onChange, iconProps={}, labelProps={}}) => {
    return (
        <Box border round="xxsmall">
            <RadioButtonGroup
                name={name}
                direction="row"
                gap="none"
                options={options}
                labelKey="name"
                {...(onChange ? {onChange} : {})}
            >
                {(option, { checked, focus, hover }) => {
                    const isLast = options[options.length - 1]?.value === option.value;
                    const isSelected = checked || option.value === value;
                    return (
                        <Box
                            background={isSelected ? 'accent' : undefined}
                            border={!isLast ? {side: 'right', color: 'border'} : undefined}
                            pad={{horizontal: 'small', vertical: 'xsmall'}}
                            direction="row"
                            gap="small"
                            align="center"
                            justify="center"
                            width="100%"
                        >
                            {option?.icon ?
                                (<FontAwesomeIcon SelectedIcon={option?.icon} size="xsmall" {...iconProps}/>) :
                                ('')}
                            <Text {...labelProps}>{sentencecase(option?.name)}</Text>
                        </Box>
                    );
                }}
            </RadioButtonGroup>
        </Box>
    )
}

export default TabToggle;